<script>
import {useUserStore} from '@/store/user'
import jsonStripFunctionsAndStringify from '~/assets/js/utils/json_cleanup.js'

export default {
  name: 'ProductJSONLD',
  props: {
    product: {
      type: Object,
      default() {
        return null
      }
    },
    brand: {
      type: Object,
      default() {
        return null
      }
    },
    category: {
      type: String,
      default() {
        return null
      }
    }
  },
  setup(props) {
    const i18n = useI18n()
    const {showInchValues} = storeToRefs(useUserStore())

    const jsonLdObj = () => {
      let description = props.product?.locales[i18n.locale.value]

      const localeUpper = i18n.locale.value.toUpperCase()
      const system = showInchValues.value ? 'Imperial' : 'Metric'
      const titleField = `locales_${localeUpper}_${system}_SalesTextECom`

      const salesText = titleField in props.product ? props.product?.sku + ' | ' + props.product[titleField] : null

      return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        'name': salesText ?? props.product?.sku + ' ' + (props.category || ''),
        'description': description,
        'brand': {
          '@type': 'Brand',
          'name': props.brand?.Brand,
          'logo': props.brand?.BigLogo?.url
        },
        'review': [{
          '@type': 'Review',
          'author': {
            '@type': 'Organization',
            'name': 'Freudenberg FST GmbH'
          }
        }]
      }
    }
    const jsonLd = jsonStripFunctionsAndStringify(jsonLdObj())

    useHead({
      script: [
        {
          type: 'application/ld+json',
          children: jsonLd
        }
      ]
    })
    return {
    }
  }
}
</script>
